import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { ImExit, ImMenu } from "react-icons/im";
import { useBreakpointContext } from "../providers/breakpoint-provider";

const mbalLogo = "/logo-mbal.png";

const Headerbar = () => {
  const [isMobileMenu, setIsMobileMenu] = useState(false);
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false);
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const { breakpoint } = useBreakpointContext();
  const { state, dispatch } = useAuth();
  const location = useLocation();

  const handleMobileMenuVisibility = () => {
    setIsMobileMenuVisible((prevState) => !prevState);
  };

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
  };

  useEffect(() => {
    setUserLoggedIn(state?.user != null);
  }, [state]);

  useEffect(() => {
    setIsMobileMenu(() => {
      const newIsMobile = breakpoint.id < 4;
      // console.log(newIsMobile + " | " + JSON.stringify(breakpoint)); // ✅ Logs correct value
      return newIsMobile;
    });
  }, [breakpoint]);

  const menuItems = [
    {
      item: "/LabResults",
      label: "ЛАБОРАТОРНИ / LAB.",
    },
    {
      item: "/ImagingResults",
      label: "ОБРАЗНИ / IMAGING",
    },
    {
      item: "/MicrobiologyResults",
      label: "МИКРОБИОЛОГИЯ / MICROBIO.",
    },
    {
      item: "/PathoAnatomyResults",
      label: "ПАТОАНАТОМИЯ / PATHOANATOMY",
    },
  ];

  return (
    <>
      {/* <div
        className="
          relative flex flex-shrink-0 w-full h-20 justify-center bg-white
          after:absolute after:bottom-0 after:w-full after:h-[2px] after:bg-[--primary-color] after:opacity-50
        "
      > */}
      <div
        className="
          relative flex flex-col w-full min-h-20 items-center justify-start
          after:absolute after:bottom-0 after:w-full after:h-[2px] after:bg-[--primary-color] after:opacity-50
          bg-neutral-100
          shadow-md
        "
      >
        {/* NAVBAR */}
        <div className="container flex w-full items-center justify-between px-10 py-3 text-sm font-bold tracking-wider">
          {/* LOGO */}
          <div className="flex gap-5 items-center">
            <Link to={"/"} className="flex gap-5 items-center">
              <img
                src={mbalLogo}
                alt="MBAL Logo"
                className="flex max-w-14 h-auto"
              />
            </Link>
          </div>

          {/* MENU LINKS */}
          {userLoggedIn && (
            <div className="flex text-xs gap-2 items-center">
              {isMobileMenu ? (
                <>
                  <button
                    // NOTE : for mobile menu, we use inversed stylies as it does the job.
                    // the menu button looks like a toggle my using -> isMobileMenuVisible ? "navbar-link-inactive" : "navbar-mobile-menu-button"
                    className={`relative ${isMobileMenuVisible ? "navbar-link-inactive" : "navbar-mobile-menu-button"}`}
                    onClick={handleMobileMenuVisibility}
                    title="Меню"
                  >
                    <ImMenu size={16} />
                  </button>
                </>
              ) : (
                menuItems.map((item, index) =>
                  location.pathname === item.item ? (
                    <div key={index} className="navbar-link-inactive">
                      {item.label}
                    </div>
                  ) : (
                    <Link key={index} to={item.item} className="navbar-link">
                      {item.label}
                    </Link>
                  )
                )
              )}

              <button
                className="navbar-link"
                onClick={handleLogout}
                title="Излез / Exit"
              >
                <ImExit size={16} />
              </button>
            </div>
          )}
        </div>
        {/* MOBILE MENU */}
        {userLoggedIn && isMobileMenu && isMobileMenuVisible && (
          <>
            <div
              className="container flex flex-col w-full h-fit
                gap-1 py-5 px-3 items-end
              "
            >
              {menuItems.map((item, index) =>
                location.pathname === item.item ? (
                  <div
                    key={index}
                    className="w-full text-end text-xl sm:text-sm p-2 bg-secondary-color text-white transition-colors"
                  >
                    {item.label}
                  </div>
                ) : (
                  <Link
                    key={index}
                    to={item.item}
                    onClick={handleMobileMenuVisibility}
                    className="w-full text-end text-xl sm:text-sm p-2 secondary-color hover:bg-neutral-200 transition-colors"
                  >
                    {item.label}
                  </Link>
                )
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Headerbar;
